import { Tooltip } from "flowbite-react";
import {InfoIcon} from 'components/icons/info-icon';
export default function ToolTipCompany({content}) {
  return (
    <Tooltip content={<div className="max-w-[220px] text-xs text-white text-center" 
    dangerouslySetInnerHTML={{ __html: content }}  ></div>}>
      <InfoIcon className="w-4 h-4" />
    </Tooltip>
  );
}
